

    import {Component, Prop, Vue} from 'vue-property-decorator';

    @Component({})
    export default class ThankYou extends Vue {
        @Prop() public subscriber: any;
    }

